import Axios from "../util/axiosInstance";

export const getUserInfo = (instrId) => {
  if (instrId) {
    return Axios.get(`/api/TrainerProfile/Get?instrId=${instrId}`)
  }
  return Axios.get('/api/TrainerProfile/Get')
};

export const postPreferenceApi = (payload) => {
  return Axios.post("/api/TrainerProfile/UpdatePreferences", payload)
 
};